export class ManualTicketResult {
  isSuccess: boolean;
  srNumber: string;
  resultDescription: string

}
